import { render, staticRenderFns } from "./OfficeRoleUser.vue?vue&type=template&id=6d63d310&scoped=true&"
import script from "./OfficeRoleUser.vue?vue&type=script&lang=js&"
export * from "./OfficeRoleUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d63d310",
  null
  
)

export default component.exports